/** @jsx jsx */
import React, { useState, useEffect } from 'react';
import { jsx } from '@emotion/core';
import BlockUI from 'components/molecules/BlockUi';
import FormContents from 'components/atoms/Form/FormContents';
import OrganizationFilteredTree from 'components/organismos/organization/OrganizationFilteredTree/OrganizationFilteredTree';
import DatePicker from 'components/molecules/DatePicker';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import useMediaAnalysisBillList from 'components/organismos/master/general/salesPage/mediaAnalysisBillList/hook';
import MediaAnalysisBillListTable from 'components/organismos/master/general/salesPage/mediaAnalysisBillList/mediaAnalysisBillLisTable';
import IconLabelButton from 'components/molecules/IconLabelButton';
import { useDownload } from './hook';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

const MediaAnalysisBillList: React.FC<{}> = () => {
  const {
    isLoading,
    listMediaAnalysisBill,
    functionType,
    orgCode,
    setOrgCode,
    loginStaffCode,
    categoryAry,
    setCategoryAry,
    selectedDateFrom,
    setSelectedDateFrom,
    selectedDateTo,
    setSelectedDateTo
  } = useMediaAnalysisBillList();

  const [isActiveRow, setActiveRow] = useState();
  const [isActiveColumn, setActiveColumn] = useState();

  const handleClickActive = (row: number, column: number) => {
    setActiveRow(row);
    setActiveColumn(column);
  };

  const [orgName, setorgName] = useState(sessionStorage.getItem('loginUser.orgName') ? sessionStorage.getItem('loginUser.orgName') : '');
  const targetPeriodData = `対象期間：${moment(selectedDateFrom).format('YYYY/MM/DD')}~${moment(selectedDateTo).format('YYYY/MM/DD')}`;

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen)

  return (
    <BlockUI blocking={isLoading}>
      <FormContents>
        <FlexBox>
          <FlexBoxItem>
            <DatePicker
              dateFormat="yyyy年MM月dd日"
              date={selectedDateFrom}
              changeDate={(date: Date) => {
                if (date !== null) {
                  setSelectedDateFrom(date);
                  sessionStorage.setItem('dateSelectSalePageFrom11', `${date}`);
                }
              }}
              isFullWidth={true}
            />
          </FlexBoxItem>
          <FlexBoxItem>
            <span style={{ margin: '0 30px' }}>～</span>
          </FlexBoxItem>
          <FlexBoxItem>
            <DatePicker
              dateFormat="yyyy年MM月dd日"
              date={selectedDateTo}
              changeDate={(date: Date) => {
                if (date !== null) {
                  setSelectedDateTo(date);
                  sessionStorage.setItem('dateSelectSalePageTo11', `${date}`);
                }
              }}
              isFullWidth={true}
            />
          </FlexBoxItem>
        </FlexBox>
        <div style={{ marginLeft: '8px' }}>
          <OrganizationFilteredTree
            functionType={functionType}
            orgCallback={(args: string | Array<string>) => {
              setOrgCode(String(args));
            }}
            orgCategoryCallback={
              (args: Array<string>) => {
                setCategoryAry(args);
              }
            }
            orgNameCallback={(arg: any) => {
              setorgName(String(arg));
            }}
            initOrgValue={String(orgCode)}
            staffCode={loginStaffCode}
            orgLabel="組織名"
            addAllItem={true}
          />
        </div>
        <MediaAnalysisBillListTable
          listMediaAnalysisBill={listMediaAnalysisBill}
          isActiveRow={isActiveRow}
          isActiveColumn={isActiveColumn}
          handleClickActive={handleClickActive}
          orgName={orgName}
          targetPeriodData={targetPeriodData}
          roleScreen={roleScreen}
        />
      </FormContents>
    </BlockUI>
  );
};
export default MediaAnalysisBillList;
